//
// Generated class DeliveryRoute
//

/// <reference path="DeliveryRoute_ManagedObject.ts" />

class DeliveryRoute extends DeliveryRoute_ManagedObject
{
}
